<template>
  <div class="riskInfo">
    <!-- fixed -->
    <van-nav-bar
      left-arrow
      title="风险测评信息"
      :z-index="10"
      @click-left="goableBack()"
    ></van-nav-bar>

    <van-cell-group class="riskInfo-list riskInfo-links">
      <!-- 风险评测 -->
      <van-cell
        :class="[
          'menu',
          { 'riskInfo-list-item-active': userInfo.userLevel > 0 },
        ]"
        :value="userInfo.riskMsg"
        is-link
        @click="onTo('questions')"
      >
        <div slot="title">
          <span class="van-cell-text">风险测评</span>
        </div>
      </van-cell>
      <!-- 风险测评最新PDF文件 -->
      <van-cell
        class="menu last"
        title="查看签名文件"
        is-link
        @click="clickLookSiginFile"
      ></van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import * as RisksApi from "@/api/risks";
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Button,
  Dialog,
  Toast,
} from "vant";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["os", "channel", "userInfo"]),
  },

  methods: {
    ...mapActions(["getUserInfo"]),

    onTo(path) {
      const query = { from: "options" };
      let _allow = true; //  是否允许前往下一页
      let _dialog = "";
      switch (path) {
        case "questions":
          _allow = true;
          // _dialog = this.userInfo.assessNum < 1 ? "" : "是否重新测评";
          _dialog = this.userInfo.userLevel < 1 ? "" : "是否重新测评";
          if (this.userInfo.userLevel > 0) {
            if (this.userInfo.assessNum >= 3) {
              if (!this.userInfo.forceAssess) {
                this.$toast("一年之内最多只能进行3次评测");
                return false;
              }
            }
          }
          break;

        default:
          break;
      }
      if (!_allow) {
        return;
      }
      if (_dialog) {
        Dialog.confirm({ title: "提示", message: _dialog }).then(() => {
          this.$router.push({
            name: path,
            query: Object.assign(
              { redirect: this.$route.query.redirect },
              query
            ),
          });
        });
      } else {
        this.$router.push({
          name: path,
          query: Object.assign({ redirect: this.$route.query.redirect }, query),
        });
      }
    },
    clickLookSiginFile() {
      this._showLoading()
      RisksApi.riskSignFile()
        .then((data) => {
          console.log("data == %O", data);
          if (data) {
            //重定向到签字信息
            // window.location = encodeURI(data);
            this.$router.push( {name: 'lookPdfUrlFile', query: {title: '查看签名文件', url: encodeURI(data)}})
          }
          this._dismissLoading()
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 下边框线条
::v-deep .van-cell.menu:not(:last-child)::after {
  border: none;
}

::v-deep .van-cell {
  border-bottom: 1px solid #ebebeb;
  .van-cell__title {
    color: #666;
    font-size: 15px;
  }
}

.last {
  border: none;

  .van-cell__value {
    color: #999;
    font-size: 14px;
  }
}
// --------------------------------------------------
.riskInfo {
  background-color: #f1f5f8;
  min-height: 100vh;
  position: relative;

  &-links {
    &-img {
      width: 20px;
      height: 20px;
      top: 2px;
      margin-right: 10px;
    }
  }

  &-user-info {
    > .van-cell {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

  &-list {
    padding: 0 20px;

    > .options-list-item-active {
      .van-cell__value {
        color: #999;
        font-size: 14px;
      }
    }
  }

  &-portrait {
    &-img {
      width: 50px;
      height: 50px;
      position: relative;
    }
    &-info {
      margin-left: 14px;
      margin-top: 12px;
    }
    .options-pi-title,
    .options-pi-level {
      line-height: 1;
    }
    .options-pi-title {
    }
    .options-pi-level {
      margin-top: 4px;
      font-size: 10px;
      color: #6f4829;
    }
    .options-pil-name,
    .options-pil-icon {
      display: inline-block;
      vertical-align: middle;
    }
    .options-pil-name {
    }
    .options-pil-icon {
      > img {
        width: 10px;
        margin-left: 6px;
      }
    }
  }

  &-control {
    background-color: transparent;
    position: absolute;
    bottom: 0;
  }
}
</style>
